module.exports = __webpack_public_path__ + "img/solutions_1.4967233e.svg";